/* 매체별보고서 상태관리 */
import {getThisMonth} from "../../../common/DateUtils";
import {atom} from "jotai";
import {ReportsMediaModal} from "../Media";
import {decimalFormat, moneyToFixedFormat} from "../../../common/StringUtils";
import {defaultCondition} from "./common";
import {getReportMetricColor} from "../../../components/reports/ReportMetricTheme";

export const reportsMedia = {
  pageSize: 30,
  currentPage: 1,
  searchStartDate: getThisMonth().startDay,
  searchEndDate: getThisMonth().endDay,
  productType: null,
  targetingType: null,
  exchangeSearchType: null,
  deviceType: null,
  agentType: defaultCondition.agentType.map(obj => obj.value),
  sortType: null
}

/* 매체별 상세보고서 상태관리 */
export const reportsMediaDetailAtom = {
  pageSize: 30,
  currentPage: 1,
  searchStartDate: getThisMonth().startDay,
  searchEndDate: getThisMonth().endDay,
  productType: null,
  targetingType: null,
  exchangeSearchType: null,
  deviceType: null,
  agentType: defaultCondition.agentType.map(obj => obj.value),
  sortType: null
}

/* 매체별보고서 컬럼 */
export const reportsStaticsMediaColumn = [
  {
    name: 'siteName', header: '매체명', minWidth: 150,
    render: ({value, data}) => {
      return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div className={'ellipsis'}
                 style={{whiteSpace: "break-spaces"}}>{value}</div>
            <ReportsMediaModal userId={data.userId} siteName={value}/>
          </div>
      )
    }
  },
  {
    name: 'requestCount',
    header: '요청수',
    type: 'number',
    render: ({value}) => <span>{decimalFormat(value)}</span>
  },
  {
    name: 'exposureCount',
    header: '노출수',
    type: 'number',
    render: ({value}) => <span>{decimalFormat(value)}</span>
  },
  {
    name: 'revenueAmount',
    header: '수익금',
    textAlign: 'end',
    type: 'number',
    render: ({value}) => <span className={'won'}
                               style={{color: getReportMetricColor('revenueAmount')}}>{decimalFormat(
        value)}</span>
  },
  {
    name: 'ecpm',
    textAlign: 'end',
    header: 'ECPM',
    sortable: false,
    render: ({data}) => {
      let value = data?.exposureCount !== 0 ? (data?.revenueAmount
          / data.exposureCount) * 1000 : 0;
      return <p className={'won'} style={{color: getReportMetricColor('ecpm')}}>{moneyToFixedFormat(
          value)}</p>
    }
  },
]

/* 매체별보고서 아코디언 컬럼 */
export const reportsStaticsInventoryByMediaColumn = [
  {name: 'inventoryName', header: '지면명', sortable: false},
  {
    name: 'requestCount',
    header: '요청수',
    type: 'number',
    sortable: false,
    render: ({value}) => <span>{decimalFormat(value)}</span>
  },
  {
    name: 'exposureCount',
    header: '노출수',
    type: 'number',
    sortable: false,
    render: ({value}) => <span>{decimalFormat(value)}</span>
  },
  {
    name: 'revenueAmount',
    header: '수익금',
    type: 'number',
    textAlign: 'end',
    sortable: false,
    render: ({value}) => <span>{decimalFormat(value)}</span>
  },
  {
    name: 'ecpm',
    textAlign: 'end',
    header: 'ECPM',
    sortable: false,
    render: ({data}) => {
      let value = data.exposureCount !== 0 ? (data?.revenueAmount
          / data.exposureCount) * 1000 : 0;
      return <p className={'won'}>{moneyToFixedFormat(value)}</p>
    }
  }
]

/* 매체별보고서 상세 컬럼 */
export const reportsStaticsMediaDetailColumn = [
  {name: 'historyDate', header: '통계일'},
  {
    name: 'requestCount',
    header: '요청수',
    type: 'number',
    render: ({value}) => <span>{decimalFormat(value)}</span>
  },
  {
    name: 'exposureCount',
    header: '노출수',
    type: 'number',
    render: ({value}) => <span>{decimalFormat(value)}</span>
  },
  {
    name: 'revenueAmount',
    header: '수익금',
    textAlign: 'end',
    type: 'number',
    render: ({value}) => <span className={'won'}
                               style={{color: getReportMetricColor('revenueAmount')}}>{decimalFormat(
        value)}</span>
  },
  {
    name: 'ecpm',
    textAlign: 'end',
    header: 'ECPM',
    sortable: false,
    render: ({data}) => {
      let value = data?.exposureCount !== 0 ? (data?.revenueAmount
          / data.exposureCount) * 1000 : 0;
      return <p className={'won'} style={{color: getReportMetricColor('ecpm')}}>{moneyToFixedFormat(
          value)}</p>
    }
  }
]
/* 매체별보고서 아코디언 결과 */
export const reportsStaticsMediaDetail = atom({
  "totalCount": 0,
  "totalPages": 0,
  "currentPage": 1,
  "rows": []
})
